import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { ARCH_NODES, ARCH_LINKS } from '../data/mockData';

// 区块3：技术架构关系图（流程图）
export default function ChartGraphArch() {
  const categories = [
    { name: '输入层', itemStyle: { color: '#06b6d4' } },
    { name: 'AI分析层', itemStyle: { color: '#fbbf24' } },
    { name: '应用层', itemStyle: { color: '#22c55e' } },
  ];

  const option = {
    backgroundColor: 'transparent',
    title: {
      text: 'AI微格实训技术架构',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: categories.map((c) => c.name),
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    series: [
      {
        type: 'graph',
        layout: 'force',
        data: ARCH_NODES.map((node) => ({
          ...node,
          itemStyle: {
            color: categories[node.category].itemStyle.color,
            shadowBlur: 20,
            shadowColor: categories[node.category].itemStyle.color,
          },
          label: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 'bold',
          },
        })),
        links: ARCH_LINKS.map((link) => ({
          ...link,
          lineStyle: {
            color: '#fbbf24',
            width: 2,
            curveness: 0.1,
          },
        })),
        categories,
        roam: true,
        force: {
          repulsion: 400,
          edgeLength: [80, 160],
          gravity: 0.1,
        },
        emphasis: {
          focus: 'adjacency',
          lineStyle: { width: 4 },
        },
        lineStyle: {
          color: 'source',
          curveness: 0.1,
        },
        animationDuration: 1500,
        animationEasing: 'cubicOut',
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 480 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
